export default "__VITE_ASSET__DkR_m4lk__"